module.exports = __webpack_public_path__ + "img/TZS09380.afa7ae06.jpeg";